module.exports = __webpack_public_path__ + "img/treatment-triangle-dark.a6047941.svg";